module.exports = __webpack_public_path__ + "static/media/UPGCatalogBanner-md.78b53184.jpg";